import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24722fb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "main-container" }
const _hoisted_3 = { class: "tip-line1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tip-line2" }, [
  /*#__PURE__*/_createTextVNode(" Share your CV with us. (Upload either doc, docx, pdf, or txt file types of Max 5MB)"),
  /*#__PURE__*/_createElementVNode("sup", null, "*")
], -1))
const _hoisted_5 = { class: "el-upload__text" }
const _hoisted_6 = { class: "file-list" }
const _hoisted_7 = {
  key: 0,
  class: "red"
}
const _hoisted_8 = { class: "moka-form" }
const _hoisted_9 = { class: "form-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "form-item-title" }, " Contact Information ", -1))
const _hoisted_11 = { class: "form-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "form-item-title" }, " Contact Details ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "*", -1))
const _hoisted_14 = { class: "red" }
const _hoisted_15 = { class: "tr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_Right = _resolveComponent("Right")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_scrollbar, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, [
            _createTextVNode(" You are applying for - "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.jobTitle), 1)
          ]),
          _hoisted_4,
          _createVNode(_component_el_upload, {
            class: "upload-demo",
            drag: "",
            action: "#",
            accept: ".doc, .docx, .txt, .pdf",
            "file-list": _ctx.fileList,
            "auto-upload": false,
            "on-change": _ctx.getFile,
            "show-file-list": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                default: _withCtx(() => [
                  _createVNode(_component_upload_filled)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(" Drop file here or "),
                _createVNode(_component_el_link, { type: "primary" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Upload Resume/CV ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["file-list", "on-change"]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.fileList && _ctx.fileList.length > 0 ? _ctx.fileList[0].name : ''), 1),
          (_ctx.showExceedText)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.exceedText), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_form, {
              "label-position": "top",
              "label-width": "100px",
              rules: _ctx.rules,
              ref: "mokaFormRef",
              model: _ctx.mokaForm
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        xs: 24,
                        sm: 24,
                        md: 12,
                        lg: 12,
                        xl: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            required: "",
                            label: "First name",
                            prop: "firstName"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                clearable: "",
                                modelValue: _ctx.mokaForm.firstName,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mokaForm.firstName) = $event)),
                                placeholder: "John"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        xs: 24,
                        sm: 24,
                        md: 12,
                        lg: 12,
                        xl: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            required: "",
                            label: "Last name",
                            prop: "lastName"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                clearable: "",
                                modelValue: _ctx.mokaForm.lastName,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mokaForm.lastName) = $event)),
                                placeholder: "Doe"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        xs: 24,
                        sm: 24,
                        md: 12,
                        lg: 12,
                        xl: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            required: "",
                            label: "Email",
                            prop: "email"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                type: "email",
                                clearable: "",
                                modelValue: _ctx.mokaForm.email,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mokaForm.email) = $event)),
                                placeholder: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.mokaForm.referrer)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 0,
                            xs: 24,
                            sm: 24,
                            md: 12,
                            lg: 12,
                            xl: 12
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: "KN Referral Email",
                                prop: "referrer"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    clearable: "",
                                    modelValue: _ctx.mokaForm.referrer,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mokaForm.referrer) = $event)),
                                    placeholder: "example@kuehne-nagel.com",
                                    disabled: _ctx.isDisabledReferrer
                                  }, null, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        xs: 24,
                        sm: 24,
                        md: 12,
                        lg: 12,
                        xl: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            required: "",
                            label: "Address Line 1",
                            prop: "addressLine1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                clearable: "",
                                modelValue: _ctx.mokaForm.addressLine1,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mokaForm.addressLine1) = $event)),
                                placeholder: "123 Main St"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        xs: 24,
                        sm: 24,
                        md: 12,
                        lg: 12,
                        xl: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "Address Line 2",
                            prop: "addressLine2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                clearable: "",
                                modelValue: _ctx.mokaForm.addressLine2,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mokaForm.addressLine2) = $event)),
                                placeholder: "Apt 456"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        xs: 24,
                        sm: 24,
                        md: 12,
                        lg: 12,
                        xl: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            required: "",
                            label: "City",
                            prop: "city"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                clearable: "",
                                modelValue: _ctx.mokaForm.city,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.mokaForm.city) = $event)),
                                placeholder: "California"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        xs: 24,
                        sm: 24,
                        md: 12,
                        lg: 12,
                        xl: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            required: "",
                            label: "Country/State/Province",
                            prop: "province"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                clearable: "",
                                modelValue: _ctx.mokaForm.province,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.mokaForm.province) = $event)),
                                placeholder: "Los Angeles"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        xs: 24,
                        sm: 24,
                        md: 12,
                        lg: 12,
                        xl: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            required: "",
                            label: "Country",
                            model: "mokaForm.country"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.mokaForm.country,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mokaForm.country) = $event)),
                                clearable: "",
                                filterable: "",
                                placeholder: "Please enter and select",
                                class: "select-line1",
                                size: "default",
                                onChange: _ctx.changeCountryCode
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryValue, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.country_code,
                                      label: item.english_name,
                                      value: item.phone_code
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        xs: 24,
                        sm: 24,
                        md: 12,
                        lg: 12,
                        xl: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "Zip Code",
                            prop: "zipCode"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                clearable: "",
                                modelValue: _ctx.mokaForm.zipCode,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.mokaForm.zipCode) = $event)),
                                placeholder: "90210"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        xs: 8,
                        sm: 8,
                        md: 4,
                        lg: 4,
                        xl: 4
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            required: "",
                            label: "Country Code",
                            prop: "countryCode"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.mokaForm.countryCode,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.mokaForm.countryCode) = $event)),
                                clearable: "",
                                filterable: "",
                                placeholder: "Please enter and Select",
                                size: "default"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryValue, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.country_code,
                                      label: `+` + item.phone_code,
                                      value: item.country_code
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        xs: 16,
                        sm: 16,
                        md: 8,
                        lg: 8,
                        xl: 8
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            required: "",
                            label: "Phone",
                            prop: "phone"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                clearable: "",
                                modelValue: _ctx.mokaForm.phone,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.mokaForm.phone) = $event)),
                                placeholder: "18888887777"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        xs: 24,
                        sm: 24,
                        md: 12,
                        lg: 12,
                        xl: 12
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        xs: 24,
                        sm: 24,
                        md: 12,
                        lg: 12,
                        xl: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { prop: "agreement" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_checkbox, {
                                label: "By submitting my personal and application data, I fully accept the for the country my application relates to.",
                                name: "type",
                                modelValue: _ctx.agreement,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.agreement) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_el_link, {
                                type: "primary",
                                class: "agreement-line",
                                href: "https://privacy.kuehne-nagel.com/en/-/website-privacy-policy#/job-portal-policy/en_GB",
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Kuehne+Nagel Data Privacy Statement "),
                                  _hoisted_13
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        xs: 14,
                        sm: 14,
                        md: 22,
                        lg: 22,
                        xl: 22
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.submitError), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        xs: 8,
                        sm: 8,
                        md: 2,
                        lg: 2,
                        xl: 2
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.submitForm,
                              loading: _ctx.loading,
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Submit"),
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Right)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick", "loading"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["rules", "model"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}